import React from 'react';
import { ModalHeader } from '../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalBody } from '../../../../../CommonComponents/OPL/Modal/ModalBody';
import { Alert } from '../../../../../CommonComponents/OPL/Alert/Alert';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { ModalFooter } from '../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../../CommonComponents/OPL/Modal/Modal';
import { useDeleteModelGroupMutation } from '../../api/useDeleteModelGroupMutation';
import { ModelGroupDTO } from '../../api/useModelGroupsQuery';

interface Props {
  modelGroup: Partial<ModelGroupDTO>;
  onClose(): void;
  onUpsertModelGroupClose(): void;
}

export const DeleteModelGroup: React.FC<Props> = ({
  modelGroup,
  onClose,
  onUpsertModelGroupClose,
}) => {
  const { mutateAsync: deleteModelGroup, isLoading, error } = useDeleteModelGroupMutation();

  const { groupId, groupName } = modelGroup;

  const handleDeleteModelGroup = async () => {
    if (groupId && groupName) {
      try {
        await deleteModelGroup({ groupId, groupName });

        onClose();
        onUpsertModelGroupClose();
      } catch (err) {
        // Ignore
      }
    }
  };

  return (
    <Modal isOpen onRequestClose={onClose} size="medium" contentLabel="Delete Model Group">
      <ModalHeader variant="warning">Warning</ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <ModalBody>
        {error && <Alert message={error.message} variant="error" mb="16" />}

        <Text>Are you sure you want to delete this model group?</Text>
        <Text>Doing so will impact any client plans currently utilizing it.</Text>
      </ModalBody>

      <ModalFooter>
        <Button onClick={onClose} variant="subtleInactive" autoFocus mr="12">
          Cancel
        </Button>

        <Button variant="error" onClick={handleDeleteModelGroup} isLoading={isLoading}>
          Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
};
